"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  skillLevel: {
    id: "tooltip.skill.skillLevel",
    defaultMessage: "Skill Level",
    description: ""
  },
  requiredMana: {
    id: "tooltip.skill.requiredMana",
    defaultMessage: "Required Mana",
    description: ""
  },
  requiredStamina: {
    id: "tooltip.skill.requiredStamina",
    defaultMessage: "Required Stamina",
    description: ""
  },
  requiredLevel: {
    id: "tooltip.skill.requiredLevel",
    defaultMessage: "Required Level",
    description: ""
  },
  target: {
    id: "tooltip.skill.target",
    defaultMessage: "Target",
    description: ""
  },
  friendly: {
    id: "tooltip.skill.target.friendly",
    defaultMessage: "Friendly",
    description: ""
  },
  deadBody: {
    id: "tooltip.skill.target.deadBody",
    defaultMessage: "Dead Body",
    description: ""
  },
  partyMember: {
    id: "tooltip.skill.target.partyMember",
    defaultMessage: "Party Member",
    description: ""
  },
  allPartyMembers: {
    id: "tooltip.skill.target.allPartyMembers",
    defaultMessage: "All Party Members",
    description: ""
  },
  hostile: {
    id: "tooltip.skill.target.hostile",
    defaultMessage: "Hostile",
    description: ""
  },
  currentLevel: {
    id: "tooltip.skill.currentLevel",
    defaultMessage: "Current Level",
    description: ""
  },
  nextLevel: {
    id: "tooltip.skill.nextLevel",
    defaultMessage: "Next Level",
    description: ""
  }
});

exports.default = _default;